import { Modal, Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState } from "react";
import Confetti from "react-confetti";
import { createPortal } from "react-dom";
import useWindowSize from "react-use/lib/useWindowSize";

export default function CongratulationsModal({ open, handleClose, username }) {
  const [showConfetti, setShowConfetti] = useState(true);
  const { width, height } = useWindowSize();
  const handleConfettiComplete = () => {
    setShowConfetti(false);
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        backdropFilter: "blur(4px)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          padding: "0px 20px",
        }}
      >
        {showConfetti &&
          open &&
          createPortal(
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1600,
                pointerEvents: "none",
              }}
            >
              <Confetti
                width={width}
                height={height}
                recycle={false}
                numberOfPieces={700}
                gravity={0.3}
                initialVelocityY={25}
                confettiSource={{
                  x: width / 100,
                  y: 0,
                  w: width,
                  h: 10,
                }}
                onConfettiComplete={handleConfettiComplete}
              />
            </div>,
            document.body
          )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            maxHeight: "90vh",
            p: 4,
            textAlign: "center",
            backgroundColor: "#1e1e1e",
            background: "linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%)",
            borderRadius: "16px",
            border: "1px solid rgba(255, 215, 0, 0.2)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
            color: "#e0e0e0",
            fontFamily: "Questrial",
            width: "90%",
            maxWidth: "520px",
            minWidth: "280px",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #FFD700, #FFA500, #FFD700)",
            },
          }}
        >
          {/* Success Icon with glow effect */}
          <Box
            sx={{
              backgroundColor: "rgba(255, 215, 0, 0.1)",
              borderRadius: "50%",
              p: 2,
              mb: 2,
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: 64,
                color: "#FFD700",
                filter: "drop-shadow(0 0 8px rgba(255, 215, 0, 0.4))",
              }}
            />
          </Box>

          {/* Heading */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              mb: 1.5,
              fontFamily: "Questrial",
              color: "#ffffff",
              letterSpacing: "0.5px",
            }}
          >
            Congratulations, {username}!
          </Typography>

          {/* Message */}
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              color: "#b0b0b0",
              fontFamily: "Questrial",
              lineHeight: 1.6,
              fontSize: "0.95rem",
            }}
          >
            You've successfully solved and submitted the problem for this
            certification. Your submission is currently under review and may
            take between{" "}
            <strong style={{ color: "#FFD700" }}>2 to 12 hours</strong> to be
            processed.
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body2"
            sx={{
              mb: 3.5,
              color: "#909090",
              fontFamily: "Questrial",
              fontSize: "0.875rem",
            }}
          >
            Once the review is complete, you'll be able to download your
            certificate.
          </Typography>

          {/* Close Button */}
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              px: 4,
              py: 1.25,
              fontSize: "1rem",
              fontWeight: 500,
              fontFamily: "Questrial",
              background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
              color: "#1e1e1e",
              border: "none",
              boxShadow: "0 4px 12px rgba(255, 215, 0, 0.3)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #FFC700 0%, #FF9500 100%)",
                boxShadow: "0 6px 16px rgba(255, 215, 0, 0.4)",
                transform: "translateY(-2px)",
              },
              "&:active": {
                transform: "translateY(0px)",
              },
            }}
          >
            Close
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
